/* YAMIWARD — JAPAN EXPRESS rail (日本向け).
   Lists live products tagged "fulfil-japan" — the Printful line printed at Japan
   partner facilities. Until the catalogue tags are live, a title containing
   "Japan Express" counts too.
   Progressive enhancement: the #japan-express section stays hidden until the
   products exist in /products.json, so an unsynced store shows nothing broken.
   Sold in the Japan market only (plan Task 2.5, decision D3): outside Japan
   (Shopify.country is not JP, or not set) the section stays hidden and nothing is
   fetched. The rule (which product is Japan Express, and where it sells) is
   window.YW_JAPAN in assets/storefront.js, shared with clans.js and shrine.js; the
   Liquid side is snippets/is-japan-express.liquid. Without YW_JAPAN (storefront.js
   failed to load) the section stays hidden: fail-closed. */
(function () {
    'use strict';

    function el(tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text) e.textContent = text;
        return e;
    }

    document.addEventListener('DOMContentLoaded', function () {
        var grid = document.getElementById('japan-express-grid');
        var section = document.getElementById('japan-express');
        if (!grid || !section) return;
        // Japan only (and the rule must be there): otherwise the section stays hidden
        if (!window.YW_JAPAN || !window.YW_JAPAN.inJapan()) return;
        var J = window.YW_JAPAN;

        fetch('/products.json?limit=250')
            .then(function (r) { return r.json(); })
            .then(function (data) {
                var items = (data.products || []).filter(J.isJapanExpress);
                if (!items.length) return; // line not synced yet — stay hidden

                items.sort(function (a, b) { return a.title < b.title ? -1 : 1; });

                items.forEach(function (p) {
                    var card = el('div', 'bloodline-capsule-card');

                    if (p.images && p.images[0]) {
                        var img = document.createElement('img');
                        img.src = p.images[0].src;
                        img.alt = p.title;
                        img.loading = 'lazy';
                        card.appendChild(img);
                    }
                    card.appendChild(el('div', 'bloodline-capsule-kind', p.title.split(' — ')[0].toUpperCase()));

                    var sel = document.createElement('select');
                    sel.className = 'bloodline-capsule-size';
                    (p.variants || []).forEach(function (v) {
                        if (v.available === false) return; // sold out: never offered
                        var o = document.createElement('option');
                        o.value = v.id;
                        o.textContent = v.title + ' — ' + YW_MONEY.format(v.price);
                        sel.appendChild(o);
                    });
                    card.appendChild(sel);

                    var add = el('button', 'btn btn-primary bloodline-capsule-add', 'ADD TO BAG');
                    if (!sel.options.length) { sel.disabled = true; add.disabled = true; add.textContent = 'Sold out'; }
                    add.addEventListener('click', function () {
                        // assets/shell.js owns the cart: it adds, repaints the bag and opens the drawer
                        if (!window.YW_CART) { window.location.href = '/cart/add?id=' + encodeURIComponent(sel.value) + '&quantity=1'; return; }
                        add.disabled = true;
                        var settle = function (label) {
                            add.textContent = label;
                            setTimeout(function () { add.textContent = 'ADD TO BAG'; add.disabled = false; }, 1800);
                        };
                        window.YW_CART.add(Number(sel.value), 1).then(function () { settle('ADDED ✓'); }, function () { settle('TRY AGAIN'); });
                    });
                    card.appendChild(add);

                    grid.appendChild(card);
                });

                section.style.display = '';
            })
            .catch(function () { /* progressive enhancement */ });
    });
})();
